import React from 'react';
import IconButtonBar from '../icon-button-bar';

import './style.scss';

const SimpleBio = ({ author, language = 'ko' }) => {
  const { bio, social, name } = author;

  return (
    <div className="bio-wrapper">
      <p className="title">
        <span>안녕하세요!</span>
        <span>
          {bio.role} {name}입니다.
        </span>
        <p className="description">
          세상에 가치를 더할 수 있는 사람이 되고 싶어요{' '}
          <span role="img" aria-label="tree">
            🌳
          </span>
        </p>
        <div className="social-links">
          <IconButtonBar links={social} />
        </div>
      </p>
    </div>
  );
};

export default SimpleBio;
